export default __webpack_public_path__ + "static/media/smallGoogle.09991c05.svg";